import React from 'react';
import { Link, Typography } from '@mui/material';
import { getCertificateReportUrl } from '../utils/certificateReportUrl';

/**
 * Renders certificate number as a link to the lab report (IGI/GIA) when supported, otherwise plain text.
 * For certified diamonds only; pass lab (e.g. "IGI", "GIA") when available.
 */
function CertificateLink({ certificateNumber, lab, variant, component, sx, ...rest }) {
  const url = getCertificateReportUrl(certificateNumber, lab);
  const display = certificateNumber || '—';
  if (url) {
    return (
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="primary"
        variant={variant}
        component={component}
        sx={sx}
        {...rest}
      >
        {display}
      </Link>
    );
  }
  return (
    <Typography component="span" variant={variant} sx={sx} {...rest}>
      {display}
    </Typography>
  );
}

export default CertificateLink;
